/* eslint-disable*/

import {
  BASE_URL,
  BASE_UMS_URL,
  FDS_URL,
  SS_URL,
  BASE_CATALOG_URL,
  BASE_PO_URL,
  BASE_KAAGAZ_URL,
  BASE_RMINTEGRATION_URL,
  REACT_APP_INVENTORY_BASE_URL,
  BASE_FINANCE_URL,
} from '@Src/commons/ConstantUrls';
import {
  getJwtToken,
  getUserId,
  logoutFunc,
} from '@Src/commons/Utils/authUtils';
import fetch from './fetchWithTimeout';
import { joinArrayElements } from '@Src/commons/Validations';
import { getAppSource } from '@Src/commons/Utils';

const APP_SOURCE = getAppSource();

const authorizationHeader = () => {
  const jwtToken = getJwtToken();
  return `Bearer ${jwtToken}`;
};

export const getHeaders = () => {
  const jwtTokenEnable = localStorage.getItem('jwt_token_enabled')
    ? localStorage.getItem('jwt_token_enabled')
    : false;
  const headerObj = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'Jwt-Token-Enabled': jwtTokenEnable,
    Source: APP_SOURCE,
  };
  const jwtToken = getJwtToken();
  if (jwtToken) {
    headerObj.Authorization = authorizationHeader();
    headerObj['X-tenant-id'] = '1';
    headerObj['X-source'] = APP_SOURCE;
  }
  return headerObj;
};

export const makeRequest = (props) => {
  const { url, options } = props;

  let absoluteUrl = `${BASE_URL}/${url}`;
  if (props.umsRequest) absoluteUrl = `${BASE_UMS_URL}/${url}`;
  if (props.fdsRequest) absoluteUrl = `${FDS_URL}/${url}`;
  if (props.catalogRequest) absoluteUrl = `${BASE_CATALOG_URL}/${url}`;
  if (props.poRequest) absoluteUrl = `${BASE_PO_URL}/${url}`;
  if (props.kaagazRequest) absoluteUrl = `${BASE_KAAGAZ_URL}/${url}`;
  if (props.rmintegration) absoluteUrl = `${BASE_RMINTEGRATION_URL}/${url}`;
  if (props.finance) absoluteUrl = `${BASE_FINANCE_URL}/${url}`;
  if (props.inventoryRequest)
    absoluteUrl = `${REACT_APP_INVENTORY_BASE_URL}/${url}`;

  return new Promise((resolve, reject) => {
    fetch(absoluteUrl, options)
      .then(function (response) {
        if (response.status === 204) logoutFunc();
        if (response.status >= 200 && response.status < 300) {
          return response;
        }
        const error = new Error(response && response.statusText);
        error.code = response.status;

        return response.json().then((body) => {
          const message = joinArrayElements(
            body.errors ||
              body.error ||
              body.error_messages ||
              body.message || [response.statusText]
          );

          error.message = message;
          throw error;
        });
      })
      .then((response) => response.json())
      .then((data) => resolve(data))
      .catch((error) => reject(error));
  });
};

export const get = (props) => {
  let { url, params, headers } = props;
  const options = {
    method: 'GET',
    headers: headers ? { ...getHeaders(), ...headers } : getHeaders(),
  };
  const fetchUrl = addParamsToUrl(params, url);
  return makeRequest({
    ...props,
    url: fetchUrl,
    options,
  });
};

export const putRequest = (url, data) => {
  const options = {
    method: 'PUT',
    headers: getHeaders(),
    body: JSON.stringify(data),
  };
  return makeRequest({ url, options });
};

export const putRequestUms = (url, data) => {
  const options = {
    method: 'PUT',
    headers: getHeaders(),
    body: JSON.stringify(data),
  };
  return makeRequest({ url, options, umsRequest: true });
};

export const post = (props) => {
  const { url, data } = props;
  const options = {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(data),
  };
  return makeRequest({ ...props, url, options });
};

export const postUms = (props) => {
  const { url, data = {}, headers = {} } = props;
  const header = { ...getHeaders(), ...headers };
  header.user_id = localStorage.getItem('user_id');
  const options = {
    method: 'POST',
    headers: header,
    body: JSON.stringify(data),
  };
  return makeRequest({ url, options, umsRequest: true });
};

export const putUms = (props) => {
  const { url, data } = props;
  const header = getHeaders();
  header.user_id = getUserId();
  const options = {
    method: 'PUT',
    headers: header,
    body: JSON.stringify(data),
  };
  return makeRequest({ url, options, umsRequest: true });
};

export const patchUms = (props) => {
  const { url, data } = props;
  const header = getHeaders();
  header.user_id = getUserId();
  const options = {
    method: 'PATCH',
    headers: header,
    body: JSON.stringify(data),
  };
  return makeRequest({ url, options, umsRequest: true });
};

export const getUms = (props) => {
  let { url, params } = props;
  const options = {
    method: 'GET',
    headers: getHeaders(),
  };
  const fetchUrl = addParamsToUrl(params, url);
  return makeRequest({
    url: fetchUrl,
    options,
    umsRequest: true,
  });
};
export const getRMIntegration = (props) => {
  let { url, params } = props;
  const options = {
    method: 'GET',
    headers: getHeaders(),
  };
  const fetchUrl = addParamsToUrl(params, url);
  return makeRequest({
    url: fetchUrl,
    options,
    rmintegration: true,
  });
};
export const getInventory = (props) => {
  let { url, params } = props;
  const options = {
    method: 'GET',
    headers: getHeaders(),
  };
  const fetchUrl = addParamsToUrl(params, url);
  return makeRequest({
    url: fetchUrl,
    options,
    inventoryRequest: true,
  });
};

export const postCatalog = (props) => {
  let { url, params, data } = props;
  const options = {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(data),
  };
  const fetchUrl = addParamsToUrl(params, url);
  return makeRequest({
    url: fetchUrl,
    options,
    catalogRequest: true,
  });
};

export const postPO = (props) => {
  const { url, data = {}, headers = {} } = props;
  const header = { ...getHeaders(), ...headers };
  header.source = APP_SOURCE;
  const options = {
    method: 'POST',
    headers: header,
    body: JSON.stringify(data),
  };
  return makeRequest({ url, options, poRequest: true });
};

export const postKaagaz = (props) => {
  const { url, data = {}, headers = {} } = props;
  const header = { ...getHeaders(), ...headers };
  header.source = APP_SOURCE;
  const options = {
    method: 'POST',
    headers: header,
    body: JSON.stringify(data),
  };
  return makeRequest({ url, options, kaagazRequest: true });
};

export const putFDs = (props) => {
  const { url, data } = props;
  const header = getHeaders();
  header.user_id = getUserId();
  const options = {
    method: 'PUT',
    headers: header,
    body: JSON.stringify(data),
  };
  return makeRequest({ url, options, fdsRequest: true });
};

export const postFDs = (props) => {
  const { url, data } = props;
  const header = getHeaders();
  header.user_id = getUserId();
  const options = {
    method: 'POST',
    headers: header,
    body: JSON.stringify(data),
  };
  return makeRequest({ url, options, fdsRequest: true });
};

export const getFDs = (props) => {
  let { url, params } = props;
  const options = {
    method: 'GET',
    headers: getHeaders(),
  };
  const fetchUrl = addParamsToUrl(params, url);
  return makeRequest({
    url: fetchUrl,
    options,
    fdsRequest: true,
  });
};

export const postFile = ({ url, data, umsRequest = false }) => {
  const headers = getHeaders();
  delete headers.Accept;
  delete headers['Content-Type'];
  const options = {
    method: 'POST',
    headers,
    body: data,
  };
  return makeRequest({ url, options, umsRequest });
};

export const deleteRequestUms = ({ url, data }) => {
  const options = {
    method: 'DELETE',
    headers: getHeaders(),
    body: JSON.stringify(data),
  };
  return makeRequest({ url, options, umsRequest: true });
};

export const postUmsFile = (url, data) => {
  const options = {
    method: 'POST',
    headers: getHeaders(),
    mode: 'cors',
    body: JSON.stringify(data),
  };
  return makeRequest({ url, options, umsRequest: true });
};

function addParamsToUrl(params, url) {
  if (!!params && typeof params !== 'string') {
    url += `?`;
    let count = 0;
    for (const param in params) {
      url += count > 0 ? '&' : '';
      url += Array.isArray(params[param])
        ? parametrizeUrlForArrayParam(param, params[param])
        : `${param}=${params[param]}`;
      count++;
    }
  } else if (!!params && typeof params === 'string') {
    if (!url.endsWith('/')) {
      url += '/';
    }
    url += params;
  }
  return url;
}

export const getTicketing = (props, url) => {
  const { params } = props;
  const options = {
    method: 'GET',
    headers: getHeaders(),
  };
  const fetchUrl = addParamsToUrl(params, url);
  return fetch(fetchUrl, options).then((response) => response.json());
};

export const getFinance = (props, url) => {
  const { params } = props;
  const options = {
    method: 'GET',
    headers: getHeaders(),
  };
  const fetchUrl = addParamsToUrl(params, url);
  return fetch(fetchUrl, options).then((response) => response.json());
};

export const putFinance = (url, data) => {
  const options = {
    method: 'PUT',
    headers: getHeaders(),
    body: JSON.stringify(data),
  };

  return makeRequest({ url, options, finance: true });
};

export const postFinance = (url, data) => {
  const options = {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(data),
  };

  return makeRequest({ url, options, finance: true });
};

export const postTicketing = (props) => {
  const { url, data } = props;
  const options = {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(data),
  };
  return fetch(url, options).then((response) => response.json());
};

export const postSS = (props) => {
  const { url, data } = props;
  const options = {
    method: 'POST',
    headers: {
      ...getHeaders(),
    },
    body: JSON.stringify(data),
  };
  return new Promise((resolve, reject) => {
    fetch(`${SS_URL}/${url}`, options)
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          return response;
        }
        return response.json().then((err) => {
          throw err;
        });
      })
      .then((response) => {
        resolve(response.json());
      })
      .catch((error) => reject(error));
  });
};
